import api from '../../gql/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { setCurrentWorkspaceEmergencyContactListIds } from '../slices/currentWorkspace';
import { setEmergencyContactLists } from '../slices/emergencyContactList';

export const getEmergencyContactListByWorkspaceId = createAsyncThunk(
  'monitoring/getEmergencyContactListByWorkspaceId',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const response =
          await api.emergencyContactList.getEmergencyContactListsByWorkspaceId({
            workspaceId,
          });

        if (
          response.data.getEmergencyContactListByWorkspaceId
            ?.emergencyContactLists
        ) {
          dispatch(
            setEmergencyContactLists(
              response.data.getEmergencyContactListByWorkspaceId
                .emergencyContactLists
            )
          );

          dispatch(
            setCurrentWorkspaceEmergencyContactListIds(
              response.data.getEmergencyContactListByWorkspaceId.emergencyContactLists.map(
                (resolution) => resolution.id
              )
            )
          );

          setLoading(false);
          return response.data.getEmergencyContactListByWorkspaceId
            .emergencyContactLists;
        }
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
        return null;
      }
    } else {
      setErrors('generalError');
      setLoading(false);
      return null;
    }
    return null;
  }
);

export const createEmergencyContactList = createAsyncThunk(
  'emergencyContactList/createEmergencyContactList',
  async (payload) => {
    const emergencyContactListCreated =
      await api.emergencyContactList.createEmergencyContactList({
        data: payload,
      });

    return emergencyContactListCreated.data.createEmergencyContactList;
  }
);

export const updateEmergencyContactListById = createAsyncThunk(
  'emergencyContactList/updateEmergencyContactListById',
  async (payload) => {
    const { id, data } = payload;
    const emergencyContactListUpdated =
      await api.emergencyContactList.updateEmergencyContactListById({
        id,
        data,
      });

    return emergencyContactListUpdated.data.updateEmergencyContactListById;
  }
);

export const deleteEmergencyContactListById = createAsyncThunk(
  'emergencyContactList/deleteEmergencyContactListById',
  async (payload) => {
    const { id } = payload;
    const emergencyContactListDeleted =
      await api.emergencyContactList.deleteEmergencyContactListById({
        id,
      });

    return emergencyContactListDeleted.data.deleteEmergencyContactListById;
  }
);
